var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6337 5.86647C19.8681 6.10088 19.9997 6.41877 19.9997 6.75022C19.9997 7.08168 19.8681 7.39956 19.6337 7.63397L11.7675 15.5002L19.6337 23.3665C19.8614 23.6022 19.9874 23.918 19.9846 24.2457C19.9817 24.5735 19.8503 24.887 19.6185 25.1187C19.3867 25.3505 19.0732 25.482 18.7455 25.4848C18.4177 25.4877 18.102 25.3617 17.8662 25.134L9.11623 16.384C8.88189 16.1496 8.75024 15.8317 8.75024 15.5002C8.75024 15.1688 8.88189 14.8509 9.11623 14.6165L17.8662 5.86647C18.1006 5.63213 18.4185 5.50049 18.75 5.50049C19.0814 5.50049 19.3993 5.63213 19.6337 5.86647Z",
    fill: "#162D3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.2d541ff33e6ec458d953e1ef48e94ea6.svg";
export { ForwardRef as ReactComponent };